import { Button } from 'react-bootstrap';

import { CmsButtonProps } from '~/types/Cms';

const CmsButton = ({ data }: CmsButtonProps) => {
  const alignment = data.align || 'center';
  const variant = data.level === 'tertiary' ? 'link' : data.level || 'primary';
  const linkTarget = data.link_type === 'external' ? '_blank' : '_self';
  return (
    <div style={{ textAlign: alignment }}>
      <Button href={data.link} target={linkTarget} variant={variant}>
        {data.label}
      </Button>
    </div>
  );
};

export default CmsButton;
